import React from 'react';

import { ShareableAttributesForm } from './shareable_attributes_form';

import type { AddContactWorkflow } from './workflow';

interface Props {
  children: React.ReactNode;
  workflow: AddContactWorkflow;
}

export function AddContactForm({ children, workflow }: Props) {
  if (workflow.selectingAttributesFor) {
    return (
      <ShareableAttributesForm
        contact={workflow.selectingAttributesFor}
        sharedAttributes={workflow.sharedAttributes}
        onChange={workflow.setSharedAttributes}
      />
    );
  } else {
    return (
      <div className="form-vertical-field-container">
        {children}
      </div>
    );
  }
}
